import React,{useContext} from 'react'
import PropTypes from 'prop-types'
import {SelectHostingContext, SWITCH_TAB} from "./state";

let SelectHostingTab = (props) => {
  const {list} = props
  const {state,dispatch} = useContext(SelectHostingContext)
  const renderList = function(){
    return list.map((item,index)=> {
      const {label,step} = item
      const isSelected = () => {
        const {selectedTab} = state
        return selectedTab === step
      }
      const onClick = e=>{
        e.preventDefault()
        dispatch({
          type: SWITCH_TAB,
          selectedTab: step
        })
      }
      return (
          <li key={index} className={`of-select-hosting-tab-item${isSelected()?' of-select-hosting-tab-item--selected':''}`}>
            <button className={`of-select-hosting-tab-item__button${isSelected()?' text-font-1-100 text-border-1-100':' text-font-3-100'}`} onClick={onClick}>
              {label}{isSelected()?<i className={'icon icon-of-arrow'}/>:<></>}</button>
          </li>
      )
    })
  }
  if(list && state){
    return (
        <div className={`of-select-hosting-tab`}>
          <ul className={`of-select-hosting-tab__list`}>
            {renderList()}
          </ul>
        </div>
    )
  }
  return(<></>)
}

SelectHostingTab.propTypes =  {
  list: PropTypes.array
}

export default SelectHostingTab